<template>
	<div class="flex-box">
		<div class="search-box">
			<div v-if="$hasPermission('A20301')">
				<label style="width: auto;" class="searchItemName">渠道：</label>
				<el-select v-model="SelectChannelId" placeholder="必选" v-on:change="channelIdSelectChange">
					<el-option v-for="item in options" :key="item.id" :label="item.channelName" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div v-if="$hasPermission('A20301') && options2.length!=0">
				<label class="searchItemName">子渠道：</label>
				<el-select v-model="SelectChannelChildId" placeholder="子渠道" v-if="options2.length!=0" clearable>
					<el-option v-for="item in options2" :key="item.id" :label="item.channelChildName" :value="item.id"></el-option>
				</el-select>
			</div>
			<div>
				<label class="searchItemName">设备号：</label>
				<el-select
					class="input-box"
					v-model="queryParams.deviceCode"
					placeholder="请选择设备号"
					clearable
					filterable>
					<el-option
						v-for="item in deviceOptions"
						:key="item.deviceCode"
						:label="formatDeviceLabel(item)"
						:value="item.deviceCode">
					</el-option>
				</el-select>
			</div>
			 
			<!-- <div>
				<label class="searchItemName">筛选日期：</label>
				<el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
				</el-date-picker>
			</div> -->
			<el-button style="margin-left: 10px;" type="primary" v-on:click="GetData()" icon="el-icon-search">查询</el-button>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="ExportTable()"
				icon="el-icon-download">下载统计数据信息</el-button>
		</div>
		<!-- 月度金额趋势 -->
		<div class="month-chart-wrap" v-show="tableData.length > 0">
			<div ref="amountChart" class="month-chart"></div>
		</div>
		<!--数据表格-->
		<div>
			<el-table :data="tableData" border style="width: 100%;margin: 15px 0px;">
				<el-table-column prop="month" label="日期" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="examineCount" label="体检次数" width="auto" min-width="160" align="center">
				</el-table-column>
				<el-table-column prop="photoCount" label="拍照次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="examinePhotoCount" label="体检+拍照次数" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="credentPhotoCount" label="证件照次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="healthPhotoCount" label="健康证相片次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="driverExamFormCount" label="驾驶人体检表次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="healthApplyFormCount" label="健康证申请表次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="practitionerListCount" label="从业名单次数" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="examineAmountTotal" label="体检总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.examineAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="photoAmountTotal" label="拍照总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.photoAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="examinePhotoAmountTotal" label="体检+拍照总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.examinePhotoAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="credentPhotoAmountTotal" label="证件照总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.credentPhotoAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="healthPhotoAmountTotal" label="健康证相片总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{(scope.row.healthPhotoAmountTotal||0)/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="driverExamFormAmountTotal" label="体检表总金额" width="auto" min-width="110" align="center">
					<template slot-scope="scope">
						{{(scope.row.driverExamFormAmountTotal||0)/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="healthApplyFormAmountTotal" label="申请表总金额" width="auto" min-width="110" align="center">
					<template slot-scope="scope">
						{{(scope.row.healthApplyFormAmountTotal||0)/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="practitionerListAmountTotal" label="从业名单总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{(scope.row.practitionerListAmountTotal||0)/100}}元
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- <div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
				:page-size="queryParams.pageSize" layout="sizes, prev, pager, next" :total="total">
			</el-pagination>
		</div> -->
	</div>
</template>

<script>
	import Excel from '../../../../public/tools/exportExcelHelp.js';
	import {
		post
	} from '../../../../public/request/request.js';
	import * as echarts from 'echarts';

	export default {
		data() {
			return {
				chartInstance: null,
				/**
				 * 数据总条数
				 */
				total: 0,
				/**
				 * 接口查询参数
				 */
				queryParams: {
					/**
					 * 当前页码
					 */
					pageIndex: 1,
					/**
					 * 每页条数
					 */
					pageSize: 10,
					/**
					 * 渠道
					 */
					channelId: 0,
					/**
					 * 子渠道
					 */
					channelChildId : 0,
					/**
					 * 设备号
					 */
					deviceCode:'',
				},
				/**
				 * 渠道下拉框
				 */
				options: [],
				/**
				 * 子渠道
				 */
				options2:[],
				/**
				 * 设备下拉框
				 */
				deviceOptions: [],
				/**
				 * 数据表格
				 */
				tableData: [],
				/**
				 * 新增数据model
				 */
				form: {},
				/**
				 * el-dialog 参数
				 */
				dialogFormVisible: false,
				dialogTitle: '',
				dialogOperationType: '',
				/**
				 * 日期框快捷选项
				 */
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		/**
		 * 方法
		 */
		methods: {
			/**
			 * 获取数据列表
			 */
			GetData() {
				
				const loading = this.openLoading();
				// 获取每月统计
				post('603', this.queryParams)
					.then(response => {
						if (response.data.result == 0) {
							this.tableData = response.data.data;
							this.$nextTick(() => this.updateAmountChart());
							//this.total = response.data.data.pageCount * this.queryParams.pageSize;
							loading.close();
						} else {
							this.$message.error('查询数据失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '查询数据失败');
					});
			},
			/**
			 * 导出记录表
			 */
			ExportTable(){
				const data = this.tableData.map(item => {
					return {
						'月份': item.month,
						'体检次数': item.examineCount,
						'拍照次数': item.photoCount,
						'体检+拍照次数': item.examinePhotoCount,
						'证件照次数': item.credentPhotoCount,
						'健康证相片次数': item.healthPhotoCount || 0,
						'驾驶人体检表次数': item.driverExamFormCount || 0,
						'健康证申请表次数': item.healthApplyFormCount || 0,
						'从业名单次数': item.practitionerListCount || 0,
						'体检总金额': item.examineAmountTotal / 100,
						'拍照总金额': item.photoAmountTotal / 100,
						'体检+拍照总金额': item.examinePhotoAmountTotal / 100,
						'证件照总金额': item.credentPhotoAmountTotal / 100,
						'健康证相片总金额': (item.healthPhotoAmountTotal || 0) / 100,
						'体检表总金额': (item.driverExamFormAmountTotal || 0) / 100,
						'申请表总金额': (item.healthApplyFormAmountTotal || 0) / 100,
						'从业名单总金额': (item.practitionerListAmountTotal || 0) / 100
					};
				});
				Excel.ExportExcel(data);
			},
			/**
			 * 获取渠道数据
			 */
			GetChannelData() {
				// 检查是否允许获取渠道数据
				const allowChannel = sessionStorage.getItem('allowChannel');
				if (allowChannel === 'false') {
					// 不允许获取渠道，直接调用 GetData
					this.GetData();
					return;
				}
				// 获取渠道数据列表
				post('208', {
						channelName: ''
					})
					.then(response => {
						if (response.data.result == 0) {
							this.options = response.data.data;
							if(this.options.length > 0){
								this.queryParams.channelId = this.options[0].id;
								this.GetChannelData2(this.options[0].id);
								this.GetDeviceList(this.options[0].id);
							}
							this.GetData();
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 获取子渠道数据
			 */
			GetChannelData2(channelId) {
				// 获取子渠道数据列表
				post('209', {objId: channelId})
					.then(response => {
						if (response.data.result == 0) {
							this.options2 = response.data.data;
							if(this.options2.length == 0){
								this.queryParams.channelChildId = 0;
							}
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 获取设备列表（设备号下拉框）
			 */
			GetDeviceList(channelId) {
				// 重置设备选择
				this.queryParams.deviceCode = '';
				this.deviceOptions = [];
				if (!channelId) {
					return;
				}
				post('329', { channelId })
					.then((response) => {
						if (response.data.result == 0) {
							this.deviceOptions = (response.data.data && response.data.data.list) ? response.data.data.list : [];
						} else {
							this.$message.error('获取设备列表失败:' + response.data.message);
							this.deviceOptions = [];
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取设备列表失败');
						this.deviceOptions = [];
					});
			},
			formatDeviceLabel(item) {
				const code = item && item.deviceCode != null ? String(item.deviceCode) : '';
				const addr = item && item.deviceAddress != null && item.deviceAddress !== '' ? String(item.deviceAddress) : '';
				return addr ? `${code}(${addr})` : code;
			},
			/**
			 * 页码切换事件
			 */
			handleCurrentChange(pageIndex) {
				this.GetData();
			},
			/**
			 * 每页大小切换事件
			 */
			handleSizeChange(size) {
				this.queryParams.pageSize = size;
			},
			/**
			 * 日期转yyyy-MM-dd
			 * @param {Object} today日期
			 */
			dataToString(today) {
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			/**
			 * 日期转HH:mm:ss
			 * @param {Object} today日期
			 */
			dataToString2(today) {
				let timeString = today.toLocaleTimeString('it-IT');
				return timeString;
			},
			/**
			 * 打开加载遮罩
			 */
			openLoading() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				return loading;
			},
			/**
			 * 根据表格数据更新月度金额折线图（图例可单独关闭对应系列）
			 */
			updateAmountChart() {
				const el = this.$refs.amountChart;
				if (!el) {
					return;
				}
				const rows = [...this.tableData].sort((a, b) =>
					String(a.month).localeCompare(String(b.month))
				);
				if (!rows.length) {
					if (this.chartInstance) {
						this.chartInstance.dispose();
						this.chartInstance = null;
					}
					return;
				}
				const months = rows.map((r) => r.month);
				const yuan = (v) => (Number(v) || 0) / 100;
				const option = {
					color: ['#5470c6', '#91cc75', '#fac858', '#ee6666'],
					tooltip: {
						trigger: 'axis',
						axisPointer: { type: 'cross' },
						valueFormatter: (val) => (val != null ? `${val} 元` : '')
					},
					legend: {
						data: ['体检总金额', '拍照总金额', '体检+拍照总金额', '证件照总金额'],
						selectedMode: true,
						top: 0
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: 48,
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: months,
						name: '月份',
						axisLabel: { rotate: months.length > 8 ? 30 : 0 }
					},
					yAxis: {
						type: 'value',
						name: '金额(元)',
						scale: true
					},
					series: [
						{
							name: '体检总金额',
							type: 'line',
							smooth: true,
							symbol: 'circle',
							data: rows.map((r) => yuan(r.examineAmountTotal))
						},
						{
							name: '拍照总金额',
							type: 'line',
							smooth: true,
							symbol: 'circle',
							data: rows.map((r) => yuan(r.photoAmountTotal))
						},
						{
							name: '体检+拍照总金额',
							type: 'line',
							smooth: true,
							symbol: 'circle',
							data: rows.map((r) => yuan(r.examinePhotoAmountTotal))
						},
						{
							name: '证件照总金额',
							type: 'line',
							smooth: true,
							symbol: 'circle',
							data: rows.map((r) => yuan(r.credentPhotoAmountTotal))
						}
					]
				};
				if (!this.chartInstance) {
					this.chartInstance = echarts.init(el);
				}
				this.chartInstance.setOption(option, { notMerge: true });
				this.chartInstance.resize();
			},
			_onAmountChartResize() {
				if (this.chartInstance) {
					this.chartInstance.resize();
				}
			},
			/**
			 * 渠道选择事件, 查询是否有子渠道
			 */
			channelIdSelectChange(){
				if(this.queryParams.channelId != ''){
					this.GetChannelData2(this.queryParams.channelId);
					this.GetDeviceList(this.queryParams.channelId);
				}else{
					this.options2=[];
					this.queryParams.channelChildId = 0;
					this.queryParams.deviceCode = '';
					this.deviceOptions = [];
				}
			},
		},
		/**
		 * 加载完成事件
		 */
		mounted() {
			window.addEventListener('resize', this._onAmountChartResize);
			this.GetChannelData();
			this.GetData();
		},
		beforeDestroy() {
			window.removeEventListener('resize', this._onAmountChartResize);
			if (this.chartInstance) {
				this.chartInstance.dispose();
				this.chartInstance = null;
			}
		},
		/**
		 * 计算属性
		 */
		computed: {
			/**
			 * 日期范围选择框
			 */
			dateRange: {
				get() {
					if (this.queryParams.beginTime == "" || this.queryParams.endTime == "") {
						const today = new Date();
						// 获取上个月的第一天，避免天数不一致的问题
						const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
						this.queryParams.beginTime = this.dataToString(lastMonth);
						this.queryParams.endTime = this.dataToString(today);
					}
					return [new Date(Date.parse(this.queryParams.beginTime)), new Date(Date.parse(this.queryParams
						.endTime))];
				},
				set(value) {
					if (value == null) {
						const today = new Date();
						// 获取上个月的第一天，避免天数不一致的问题
						const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
						this.queryParams.beginTime = this.dataToString(lastMonth);
						this.queryParams.endTime = this.dataToString(today);
					} else {
						this.queryParams.beginTime = this.dataToString(value[0]);
						this.queryParams.endTime = this.dataToString(value[1]);
					}
				}
			},
			/**
			 * 选择的渠道id
			 */
			SelectChannelId: {
				get() {
					if (this.queryParams.channelId == 0) {
						return '';
					} else {
						return this.queryParams.channelId;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelId = 0;
					} else {
						this.queryParams.channelId = value;
					}
				}
			},
			SelectChannelChildId:{
				get() {
					if (this.queryParams.channelChildId  == 0) {
						return '';
					} else {
						return this.queryParams.channelChildId ;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelChildId  = 0;
					} else {
						this.queryParams.channelChildId  = value;
					}
				}
			}
		}
	}
</script>

<style>
	.flex-box {
		display: flex;
		flex-direction: column;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}

	.searchItemName {
		width: 100px;
		text-align: right;
		display: inline-block;
	}

	.input-box {
		width: 200px;
	}

	.from-input {
		width: 300px;
	}

	.month-chart-wrap {
		width: 100%;
		margin: 8px 0 0;
		padding: 12px 16px;
		background: #fff;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.month-chart {
		width: 100%;
		height: 360px;
	}
</style>